module.exports = __webpack_public_path__ + "img/bg-image-23.80eb2b2a.jpg";